import {useEffect, useRef, useState} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {H3} from "@ui/titles/H3";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const SwitchButton = ({
  value,
  onChange,
  switchList,
  onClickTab,
  width = 420,
  height = 32,
  fontSize = 18,
}) => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const switchTab = (item) => {
    onClickTab && onClickTab(item);
    onChange && onChange(item.value);
    setIsOpen(false);
  };

  const renderTab = () => {
    if (!switchList || switchList.length === 0) {
      return {transform: "translateX(0)", width: "100%"};
    }

    const currentIndex = switchList.findIndex((item) => item.value === value);

    if (currentIndex === -1) {
      return {transform: "translateX(0)", width: "100%"};
    }

    const totalTabs = switchList.length;
    const tabWidth = 100 / totalTabs;
    const translateValue = currentIndex * 100;

    return {
      transform: `translateX(${translateValue}%)`,
      width: `${tabWidth}%`,
    };
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return !isMobile ? (
    <BorderArticle>
      <div
        className={styles.switch}
        style={{width: `${width}rem`, height: `${height}rem`}}
      >
        <label htmlFor={"switch-view"}>
          <i style={renderTab()} />

          {switchList &&
            switchList.map((item) => (
              <div
                key={item?.id}
                onClick={() => switchTab(item)}
                style={
                  value === item.value
                    ? {pointerEvents: "none"}
                    : {pointerEvents: "all"}
                }
              >
                <RootDesc>
                  <b
                    style={{
                      fontSize: `${fontSize}rem`,
                      ...(value === item.value
                        ? {color: "var(--white)"}
                        : {color: "var(--black)"}),
                    }}
                  >
                    {item?.name}
                  </b>
                </RootDesc>
              </div>
            ))}
        </label>
      </div>
    </BorderArticle>
  ) : (
    <div
      className={styles.dropdown}
      ref={dropdownRef}
    >
      <div
        className={styles.dropdownHeader}
        onClick={toggleDropdown}
      >
        <H3>{switchList.find((item) => value === item.value)?.name}</H3>

        <i
          style={
            isOpen ? {transform: "rotate(180deg)"} : {transform: "rotate(0deg)"}
          }
        />
      </div>

      {isOpen && (
        <div className={styles.dropdownList}>
          <BorderArticle>
            <ul>
              {switchList &&
                switchList
                  .filter((item) => value !== item.value)
                  .map((item) => (
                    <li
                      key={item?.id}
                      onClick={() => switchTab(item)}
                    >
                      <RootDesc>
                        <span>{item?.name}</span>
                      </RootDesc>
                    </li>
                  ))}
            </ul>
          </BorderArticle>
        </div>
      )}
    </div>
  );
};
